import React, { useEffect } from 'react';
import './App.css';
import Header from './Header';
import Sidebar from './Sidebar';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Mail from './Mail';
import EmailList from './EmailList';
import SendMail from './SendMail';
import Login from './Login';
import { useSelector } from 'react-redux';
import { selectSendMessageIsOpen } from './features/mailSlice';
import { login, selectUser} from './features/userSlice';
import { auth } from './firebase';
import { useDispatch } from 'react-redux';
import Widgets from './Widgets';
import EmailRow from './EmailRow';


function App() {
  const sendMessageIsOpen = useSelector(selectSendMessageIsOpen);
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  useEffect(() => {
    auth.onAuthStateChanged(user => {
      if (user) {
        // the user is logged in
        dispatch(login({
          displayName: user.displayName,
          email: user.email,
          photoURL: user.photoURL
        }))
      }
    })
  }, [])

  return (
    <Router>

      {!user ? (
        <Login />
      ) : (
      <div className="app">
        <Header />
        <div className="app__body">
          <Sidebar />

          <Routes>
            <Route path="/mail" element={<Mail />} />
            <Route index path="/" element={<EmailList />} />
          </Routes>

          <Widgets />
        </div>

        {sendMessageIsOpen && <SendMail />}
      </div>
  )}
    </Router>
  );
}

export default App;
